import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

/**
 * A send of a project's held tickets, the part of the page that started it, and whether it queued tickets (or found them
 * queued by another send): they stay held until their jobs run
 */
export interface HeldSend {
	projectId: string;
	from: 'banner' | 'healthView';
	queued: boolean;
}

/**
 * Tells each part of the page that a project's held tickets were sent, after every answer (task 4.10). The alert banner
 * and the health view's held tab both send them. A send from one changes what the other shows: the banner reads its
 * alerts again, and the health view of that project reads its held list and its counts again.
 */
@Injectable({
	providedIn: 'root'
})
export class HeldSendsService {
	private readonly sends = new Subject<HeldSend>();
	readonly sent$: Observable<HeldSend> = this.sends.asObservable();

	sent(projectId: number | string, from: HeldSend['from'], queued: boolean): void {
		this.sends.next({projectId: String(projectId), from, queued});
	}
}
